import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { useLegalDocumentsVisibility } from '../../hooks/useLegalDocumentsVisibility';

/**
 * 법정 서류 화면 진입 게이트 — 메뉴(`Layout`의 `flagKey: 'legal-obligation'`)의 **거울**이다.
 *
 * 같은 훅(`useLegalDocumentsVisibility`)을 읽으므로 「메뉴는 보이는데 들어가면 튕긴다」(막다른 길)와
 * 「들어갈 수 있는데 메뉴가 없다」(dead grant)가 구조적으로 갈리지 않는다(`layoutNavVisibility.ts` doc).
 * ⚠️ 이것은 **화면** 게이트다 — 데이터 보호는 서버 입구가 `legal-obligation`으로 한다(결정 ⓓ).
 */
export default function LegalDocumentsGate({ children }: { children: ReactNode }) {
  const companyId = useAuthStore((s) => s.currentMembership?.companyId);
  const { visible, isResolved } = useLegalDocumentsVisibility(companyId);

  if (!isResolved) {
    return (
      <div className="flex justify-center py-12" role="status" aria-label="불러오는 중">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-brand-600" />
      </div>
    );
  }
  if (!visible) return <Navigate to="/" replace />;
  return <>{children}</>;
}
